import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './app';
import configureAjax from './ajax/config';
import { PersistGate } from 'redux-persist/integration/react'
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './shared/components/ScrollToTop';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import muiTheme from './theme/muiTheme';
import { CookiesProvider } from 'react-cookie';
// This is a global variable to indicate that the Appointmint application has been loaded.
// index.html refreshes the page if this variable is not set after 5 seconds.
(window as any).appointmintLoaded = true;

console.log('START', import.meta.env);

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const { store, persistor } = configureStore(history);

// Configure ajax asynchronously (uses dynamic imports to avoid bundling dev mocks in production)
// Wait for ajax configuration before rendering to ensure interceptors are set up
configureAjax(store).then(() => {
    console.log('Ajax configured successfully');

    createRoot(document.getElementById('root')!).render(
        <MuiThemeProvider theme={muiTheme}>
        <ThemeProvider theme={theme}>
            <PersistGate persistor={persistor}>
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <ScrollToTop />
                        <ErrorBoundary>
                            <CookiesProvider>
                                <App/>
                            </CookiesProvider>
                        </ErrorBoundary>
                    </ConnectedRouter>
                </Provider>
            </PersistGate>
        </ThemeProvider>
        </MuiThemeProvider>,
    )
}).catch((error) => {
    console.error('Failed to configure ajax:', error);
    // Show error to user
    document.getElementById('root')!.innerHTML = '<div style="padding: 20px; color: red;">Failed to initialize application. Please refresh the page.</div>';
});

// registerServiceWorker();
